import React from 'react'
import styles from './ContactBtn.module.scss'
import { SmartphoneNot, Smartphone } from '../../mediaQueries/MediaQueries'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import PropTypes from 'prop-types'
import I18nLink from '../../../i18n/Link'

class ContactBtn extends React.Component {
  state = { contactBtn: this.props.contactBtn }

  static propTypes = {
    contactBtn: PropTypes.string,
  }

  static defaultProps = {
    contactBtn: 'Напишите нам',
  }

  render() {
    const { contactBtn } = this.state

    return (
      <I18nLink to="/#contact">
        <button className={styles.contact}>
          <SmartphoneNot>
            <span
              dangerouslySetInnerHTML={{
                __html: contactBtn,
              }}
            />
          </SmartphoneNot>
          <Smartphone>
            <FontAwesomeIcon icon={['fas', 'envelope']} />
          </Smartphone>
        </button>
      </I18nLink>
    )
  }
}

export default ContactBtn
